<template>
  <div style="height: inherit;">
    <Header :image="image"/>
    <div v-if="signUp" style="height: inherit; margin-bottom: -5%;">
      <form-view-component @submit="formDataSubmited($event)" ref="singUpForm"></form-view-component>
    </div>
    <div v-else style="height: 82.5%;">
      <confirmation-component :response="response" :user="email"></confirmation-component>
    </div>
    <footer-view style="margin-top: -5%;"></footer-view>
  </div>
</template>

<script>
import ConfirmationComponent from '@components/footer/profileCompletion/advertiser/ConfirmationViewComponent.vue'
import FormViewComponent from '@components/footer/profileCompletion/advertiser/FormViewComponent.vue'
import Header from '@components/design/HeaderDesign.vue'
import Config from '@utils/Config.js'
import FooterView from '@components/footer/FooterView.vue'
export default {
  name: 'SignUpAdvertiser',
  components: {
    FormViewComponent,
    ConfirmationComponent,
    Header,
    FooterView
  },
  data: function () {
    return {
      signUp: true,
      config: Config,
      image: 'asu',
      response: null,
      email: ''
    }
  },
  methods: {
    formDataSubmited (response) {
      this.response = response
      this.signUp = false
      this.email = this.$refs.singUpForm.getUser()
    }
  },
  created: function () {
  }
}
</script>
